import { render, staticRenderFns } from "./RunnitBoardsPage.vue?vue&type=template&id=52d7ca22&scoped=true"
import script from "./RunnitBoardsPage.vue?vue&type=script&lang=ts"
export * from "./RunnitBoardsPage.vue?vue&type=script&lang=ts"
import style0 from "./RunnitBoardsPage.vue?vue&type=style&index=0&id=52d7ca22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d7ca22",
  null
  
)

export default component.exports